import React, {useEffect} from 'react'
import moment from 'moment';
import {useAppDispatch, useAppSelector} from '../../../../hooks/hooks';
import useModal from '../../../../hooks/useModal';
import {useIntl} from 'react-intl';
import {Lx} from '../../../../i18n/consts';
import {Absence} from '../../../../features/absences/types';
import {deleteAbsence} from '../../../../features/absences';
import {DeleteDialog} from '../../../shared/delete-dialog';

interface Props {
    absence: Absence,
    onDelete: (item: Absence) => void,
    onCancel: () => void,
}

export default function DeleteAbsenceModal(props: Props) {
    const dispatch = useAppDispatch();
    const employees = useAppSelector((store) => store.rEmployees);
    const {open, onToggle, openModal} = useModal();
    const intl = useIntl();
    const employeeName = employees.find((employee) => employee.id === props.absence.employeeId)?.name ?? '';
    const date = moment(props.absence.date, 'YYYY-MM-DD', true);
    const formattedDate = date.isValid() ? date.format('L') : props.absence.date;
    const deleteMessage = employeeName
        ? `Delete absence for ${employeeName} on ${formattedDate}?`
        : `Delete absence on ${formattedDate}?`;

    useEffect(() => {
        openModal();
    }, [])

    const handleCancel = () => {
        onToggle();
        props.onCancel();
    }

    const handleConfirmDelete = () => {
        dispatch(deleteAbsence(props.absence.id)).unwrap().then(() => {
            props.onDelete(props.absence)
            onToggle();
        })
    }

    return (
        <DeleteDialog
            open={open}
            onCancel={handleCancel}
            onConfirmDelete={handleConfirmDelete}
            deleteHeader={intl.formatMessage({id: Lx.General.DELETE})}
            deleteMessage={deleteMessage}
            title='absence'
        />
    );
}
